var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "21AC7C0C-ACFE-4212-9335-E1EAA15ED424") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mob-app-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.2-Home-feed_storyline_start-to-charge_main-version",
    transform: "translate(-39.000000, -473.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Segmented-Controller---4-Segments-Copy",
    transform: "translate(0.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "emotion-btns",
    transform: "translate(24.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outgoing/Active-Copy-5",
    transform: "translate(0.000000, 280.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "angry",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 5.000000)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C6.71572875,0 0,6.71572875 0,15 C0,23.2842712 6.71572875,30 15,30 C23.2842712,30 30,23.2842712 30,15 C29.9906315,6.71961243 23.2803876,0.00936852177 15,0 Z",
    fill: "#EA8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.105,6.553 C8.22346793,6.31555146 8.43145544,6.13492582 8.68316144,6.05089878 C8.93486744,5.96687174 9.20965035,5.98633408 9.447,6.105 L13.447,8.105 C13.9412948,8.35187129 14.1418712,8.95270515 13.895,9.44699999 C13.6481287,9.94129482 13.0472948,10.1418713 12.553,9.895 L8.553,7.895 C8.31555146,7.77653207 8.13492582,7.56854456 8.05089878,7.31683856 C7.96687174,7.06513256 7.98633408,6.79034965 8.105,6.553 L8.105,6.553 Z",
    fill: "#FFE7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,12 C13,13.1045695 12.1045695,14 11,14 C9.8954305,14 9,13.1045695 9,12 C9,10.8954305 9.8954305,10 11,10 C12.1045695,10 13,10.8954305 13,12 Z",
    fill: "#FFE7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.041,22.662 C20.8654807,22.8610004 20.6180666,22.9820835 20.353235,22.9985886 C20.0884034,23.0150937 19.8278697,22.9256673 19.629,22.75 C16.9835869,20.4179185 13.0164131,20.4179185 10.371,22.75 C9.95678644,23.1156125 9.3246125,23.0762136 8.959,22.662 C8.5933875,22.2477864 8.63278644,21.6156125 9.047,21.25 C12.4486992,18.24993 17.5513008,18.24993 20.953,21.25 C21.1520004,21.4255193 21.2730835,21.6729334 21.2895886,21.937765 C21.3060937,22.2025966 21.2166673,22.4631303 21.041,22.662 L21.041,22.662 Z",
    fill: "#FFE7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,12 C17,10.8954305 17.8954305,10 19,10 C20.1045695,10 21,10.8954305 21,12 C21,13.1045695 20.1045695,14 19,14 C17.8954305,14 17,13.1045695 17,12 Z",
    fill: "#FFE7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.447,7.9 L17.447,9.9 C16.9527052,10.1468713 16.3518713,9.94629483 16.105,9.45199999 C15.8581287,8.95770515 16.0587052,8.35687129 16.553,8.11 L20.553,6.11 C21.0472949,5.86312872 21.6481287,6.06370515 21.895,6.558 C22.1418713,7.05229485 21.9412949,7.65312872 21.447,7.9 Z",
    fill: "#FFE7E7"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngry);
export default __webpack_public_path__ + "static/media/angry.1799714ce26b98ee789227366c5fab38.svg";
export { ForwardRef as ReactComponent };